export function isMobileViewHook(setIsMobile, width = 992) {
  const mediaQuery = window.matchMedia(`(max-width: ${width - 1}px)`);

  const updateIsMobile = () => {
    setIsMobile(mediaQuery.matches);
  };

  updateIsMobile();

  mediaQuery.addEventListener("change", updateIsMobile);

  return () => {
    mediaQuery.removeEventListener("change", updateIsMobile);
  };
}
